
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"138 0 58 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"arrow_svg__a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"196","height":"9"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h196v9H0z"}})]),_c('g',{attrs:{"mask":"url(#arrow_svg__a)"}},[_c('path',{attrs:{"d":"M-4.853 4.147a.5.5 0 000 .707l3.18 3.183a.5.5 0 00.707-.707L-3.793 4.5l2.83-2.827A.5.5 0 10-1.67.966l-3.183 3.18zm200.711.796a.5.5 0 000-.707l-3.18-3.183a.5.5 0 00-.708.706l2.827 2.83-2.829 2.827a.5.5 0 10.706.708l3.184-3.18zM-4.5 5l200.004.09.001-1L-4.5 4v1z","fill":"#232D37","mask":"url(#)"}})])])
          )
        }
      }
    